"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _color = _interopRequireDefault(require("color"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _CheckMarkIcon = _interopRequireDefault(require("../Icons/CheckMarkIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @keywords Checkbox, Toggle, Favorite, Star
 */
var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _this.handleOnMouseDown = function (e) {
      var onMouseDown = _this.props.onMouseDown;

      _this.setState({
        pressed: true
      });

      if (onMouseDown) {
        onMouseDown(e);
      }

      _this.addMouseUpEvents();
    };

    _this.handleOnMouseUp = function (e) {
      _this.setState({
        pressed: false
      });

      _this.removeMouseUpEvents();
    };

    _this.state = {
      pressed: false
    };
    return _this;
  }
  /**
   * Turns color object to str
   * @param {object} color - color to convert
   * @returns {string} alpha numeric color
   */


  _createClass(Checkbox, [{
    key: "getColorToStr",
    value: function getColorToStr(color) {
      return "rgba(".concat(color.rgb().array().join(','), ")");
    }
    /**
     * Get color based on states provided
     * @param {string} color - base color
     * @param {boolean} disabled - disabled state
     * @param {disabled} pressed - pressed state
     * @returns {string} alpha numeric color
     */

  }, {
    key: "getColor",
    value: function getColor(color, disabled, pressed) {
      var newColor = color;

      if (disabled) {
        newColor = this.getColorToStr((0, _color.default)(color).alpha(0.3));
      } else if (pressed) {
        newColor = this.getColorToStr((0, _color.default)(color).darken(0.3));
      }

      return newColor;
    }
    /**
     * Mouse down event handler
     * @param {object} e - event
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          color = _this$props.color,
          disabled = _this$props.disabled,
          label = _this$props.label,
          type = _this$props.type,
          multiLine = _this$props.multiLine,
          children = _this$props.children,
          animation = _this$props.animation,
          props = _objectWithoutProperties(_this$props, ["id", "className", "color", "disabled", "label", "type", "multiLine", "children", "animation"]);

      var CheckboxVariantName = "checkbox-variant-".concat(type);
      var multiLineClass = multiLine ? "".concat(_ThemeManager.default.getVar('classPrefix'), "-checkbox-label-multi-line") : '';
      var roundedClass = type === 'rounded' ? "".concat(_ThemeManager.default.getVar('classPrefix'), "-checkbox-rounded") : ''; // Disable transition effect when pressed is active. Pressed transition needs to be instant.

      var styleProps = {
        'data-animation': this.state.pressed ? '' : animation
      };
      var style; // Toggle variation does not support custom color

      if (type !== 'toggle') {
        style = {
          backgroundColor: this.getColor(color, disabled, this.state.pressed)
        };
      }

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, multiLineClass, roundedClass, "".concat(_ThemeManager.default.getVar('classPrefix'), "-checkbox ").concat(_ThemeManager.default.getVar('classPrefix'))),
        onMouseDown: this.handleOnMouseDown
      }, styleProps), _react.default.createElement("input", _extends({
        id: id,
        type: "checkbox",
        className: "n-checkbox",
        disabled: disabled
      }, props)), _react.default.createElement("label", {
        htmlFor: id
      }, _react.default.createElement("span", {
        htmlFor: id,
        className: (0, _classnames.default)("n-checkbox svg-".concat(_ThemeManager.default.getVar('classPrefix'), "-checkbox"), CheckboxVariantName)
      }, type === 'toggle' ? null : _react.default.createElement(_CheckMarkIcon.default, {
        className: "icon-checked",
        size: "small",
        color: _ThemeManager.default.getVar('white'),
        animatable: animation
      }), type === 'rounded' ? _react.default.createElement(_CheckMarkIcon.default, {
        className: "rounded-checkmark",
        size: "small",
        color: _ThemeManager.default.getVar('white')
      }) : null, _react.default.createElement("span", {
        className: "svg-".concat(_ThemeManager.default.getVar('classPrefix'), "-checkbox-bg"),
        style: style
      })), _react.default.createElement("span", null, label)), children && _react.default.createElement("div", {
        className: "checkbox-nested-content"
      }, children));
    }
  }, {
    key: "addMouseUpEvents",
    value: function addMouseUpEvents() {
      document.addEventListener('mouseup', this.handleOnMouseUp);
    }
  }, {
    key: "removeMouseUpEvents",
    value: function removeMouseUpEvents() {
      document.removeEventListener('mouseup', this.handleOnMouseUp);
    }
  }]);

  return Checkbox;
}(_react.default.Component);

exports.default = Checkbox;
Checkbox.CHECKBOX_TYPES = {
  DEFAULT: 'default',
  PARTIAL_CHECK: 'partial-check',
  TOGGLE: 'toggle',
  ROUNDED: 'rounded'
};
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  type: Checkbox.CHECKBOX_TYPES.DEFAULT,
  color: _ThemeManager.default.getVar('blue-1'),
  multiLine: false,
  animation: true
};
Checkbox.propTypes = {
  /**
   * checkbox must have unique id which is string type
   * user has to pass it
   */
  id: _propTypes.default.string.isRequired,

  /**
   * className is used to add extra class for checkbox wrapper
   */
  className: _propTypes.default.string,

  /**
   * type is used to define the variant of the checkbox
   */
  type: _propTypes.default.oneOf([Checkbox.CHECKBOX_TYPES.DEFAULT, Checkbox.CHECKBOX_TYPES.PARTIAL_CHECK, Checkbox.CHECKBOX_TYPES.TOGGLE, Checkbox.CHECKBOX_TYPES.ROUNDED]),

  /**
   * label is the value or label that presents next to the checkbox
   */
  label: _propTypes.default.string,

  /**
   * Specifies whether the checkbox is selected.
   */
  checked: _propTypes.default.bool,

  /**
   * to disable the checkbox.
   */
  disabled: _propTypes.default.bool,

  /**
   * function passed by user to be executed when checkbox is clicked
   */
  onClick: _propTypes.default.func,

  /**
   * Function passed by user to be executed when checkbox is moused down.
   *
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * Function passed by user to be executed when checkbox is moused up.
   *
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * function passed by user to be executed
   * when checkbox is checked/unchecked
   */
  onChange: _propTypes.default.func,

  /**
   * color of the checkbox icon
   */
  color: _propTypes.default.string,

  /**
   * Specifies whether the checkbox label is multiline.
   * This prop is to set proper line height to the label.
   */
  multiLine: _propTypes.default.bool,

  /**
   * Enable/disable animation.
   */
  animation: _propTypes.default.bool,

  /**
   * children
   */
  children: _propTypes.default.node
};